module.exports = __webpack_public_path__ + "img/pf.ff74caae.svg";